makeErrorEnum = require 'lib/make-error-enum'
assert = require 'lib/assert'
xtend = require 'xtend'
localizeServerError = require 'lib/localize-server-error'

ApiError = makeErrorEnum 'API', [
  'Unauthorized'
  'Unauthenticated'
  'Unconfirmed'
  'Timeout'
  'NoResponse'
  'NotFound'
  'Server'
  'BadRequest'
  'Conflict'
  'Other'
]

ApiError::localizedMessage = ->
  localizeServerError(this.message)

ApiError.fromResponse = (statusCode, originalText) ->
  if originalText?
    text = originalText.toLowerCase().trim()
  else
    assert statusCode == 0, "Received a response without any content!"

  switch statusCode
    when 0
      return ApiError.NoResponse()
    when 400 then switch text
      when 'invalid token' # [INVALID TOKEN]
        return ApiError.Unauthenticated()
      else
        return ApiError.BadRequest(originalText)
    when 401 then switch text
      when 'invalid token'
        return ApiError.Unauthenticated()
      when 'unauthorized permission requested', 'unauthorized organization.', 'unauthorized card permission requested'
        return ApiError.Unauthorized(originalText)
      when 'confirm to view'
        return ApiError.Unconfirmed()
    when 403 then switch text
      when 'user not logged in or invalid token.' # [WTF]
        return ApiError.Unauthenticated()
      else
        return ApiError.Unauthorized(originalText)
    when 404
      return ApiError.NotFound(originalText)
    when 408
      return ApiError.Timeout(originalText)
    when 409
      return ApiError.Conflict(originalText)

  if 500 <= statusCode < 600
    ApiError.Server(originalText)
  else
    ApiError.Other("#{statusCode}: #{originalText}")

module.exports = ApiError

# [INVALID TOKEN]
#
# The server is *very inconsistent* about this particular error.
#
# Usually it comes down as a "401: invalid token", but it frequently comes
# as "400: invalid token". But that error can also refer to [the actual token
# resource](https://trello.com/docs/api/token/), so we're *assuming* the more
# likely thing here because there's no way to distinguish what the server
# actually meant.

# [WTF]
#
# Somehow POST /1/cards/:idCard/markAssociatedNotificationsRead sends a
# completely different response from every other routes, and it sends a 403,
# even though it should be a 401. Hopefully this will be fixed at some point,
# but it happens right now.



// WEBPACK FOOTER //
// ./app/scripts/network/api-error.coffee